<template>
  <div class="input-group">
    <form class="col-12" v-if="!formSent && !formLoading" @submit.prevent="send_form" id="form-account-info">
      <div class="row">
        <div class="form-group col-6">
          <div data-placement="right info-tool"
               v-bind:data-original-title="infoTitle">
          </div>
          <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom h6 input-border-red pl-0"
                 name="cnp" id="cnp" placeholder=" " v-model="register.cnp" required />
          <label class="form-control-placeholder account-label  info-tool" style="padding-left: 0.9rem !important;" for="cnp"
                 v-bind:data-original-title="infoTitle" v-if="foreignchecking == false">
            {{__('CNP')}} ( <input type="checkbox" name="foreign" id="foreign" v-model="register.foreign" @change="foreign">
            <span v-html="infoSVG"></span>  {{__('foreign_citizen')}})
          </label>
          <label class="form-control-placeholder account-label  info-tool" style="padding-left: 0.9rem !important;" for="cnp"
                 v-bind:data-original-title="infoTitle" v-else>
            {{__('foreign-id')}} ( <input type="checkbox" name="foreign" id="foreign" v-model="register.foreign" @change="foreign">
            <span v-html="infoSVG"></span>  {{__('foreign_citizen')}})
          </label>
        </div>
        <div v-if="!user.phone_number" class="form-group mb-0 col-6 pr-0" >
          <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom h6 input-border-red pl-0"
                 name="phone_number" id="phone_number" v-model="register.phone" placeholder=" " required />
          <label class="form-control-placeholder account-label  info-tool" style="padding-left: 0.9rem !important;" for="phone_number"
                 v-bind:data-original-title="infoTitle">
            {{ __('phone') }}
            <span v-html="infoSVG"></span>
          </label>
        </div>
        <!--  Foreign citizen Start-->
        <div class="form-group col-6">
          <select id="selectLanguage" class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0">
            <option :value="v" v-for="(v, k) in availableLocales" :selected="user.language === v">{{ k }}</option>
          </select>
          <label class="form-control-placeholder ml-3" for="selectLanguage"> {{ __('select-language') }}</label>
        </div>
        <!--  Foreign citizen End-->
      </div>
      <div class="row" style="padding-left: 15px;">
        <!-- Upload documents block-->
        <div class="col-12 border text-center" style="border: 1px dashed lightgray;">
          <div class="md:w-100 center-vertically py-6 m-auto text-center">
            <label for="upload" class="cursor-pointer m-3">
              <span aria-hidden="true"
                    class="text-uppercase h7">{{__('how-to-sell.add_documents')}}</span>
              <span class="upload-disclaimer text-uppercase h7">{{__('how-to-sell.add_documents-1')}} </span>
              <input type="file" multiple="multiple" ref="upload" @change="handleFileChanges" :accept="accept"
                     id="upload" style="display:none">
            </label>
          </div>
        </div>
        <div class="items-left mb-6 mt-3 col-12" style="padding-left: 0!important; padding-right: 0!important" v-if="register.files.length">
          <div class="file-upload-container text-xs row" v-for="(file, index) in register.files" :key="index">
            <span class="text-left float-left upload-file-appraisal col-12">
              <strong class="pr-3">
                {{__('how-to-sell.file')}} {{index + 1}}:
              </strong>
              {{ file.name }}
            </span>

            <button
                class="vertical-super float-left border-white ml-1 remove-file bg-dark text-white h8 h-100 rounded-cirlcle"
                type="button" @click.prevent="register.files.splice(index, 1)" style="width:20px; margin-left: -0.7rem !important;">x</button>
            <br />
          </div>
        </div>
        <!-- End upload documents block !-->
      </div>
      <div v-if="!uploadedPhoto" class="row text-center">
        <small class="col-12 mt-1">{{__('how-to-sell.add_documents-2')}} </small>
        <small class="col-12 mt-3" v-html="__('account.account-created-with-sucess-warn')" ></small>
      </div>
      <div class="row mt-3">
        <div class="col-6 mb-5" style="margin:auto" >
          <button type="submit" style="width: 100% !important" class="btn btn-dark rounded-0 cursor-pointer">{{ __('save') }} </button>
        </div>
      </div>
    </form>
    <div class="d-flex w-100 loader center-vertically my-5" v-if="formLoading">
      <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
           xml:space="preserve">
        <path fill="#000"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25"
                            dur="0.6s" repeatCount="indefinite" />
        </path>
      </svg>
      <h5 class="h7 text-center text-muted my-4 px-3">{{__('info-sending')}}</h5>
    </div>
    <div class="iziToast-wrapper-sell iziToast-responsive-container"></div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: function() {
    return {
      accept: "image/*,application/pdf",
      register: {
        files: [],
        phone: window.AG.phone,
        cnp: window.AG.cnp,
        foreign: window.AG.foreign
      },
      hasMessage:false,
      hasError:false,
      appraisal_message:'',
      formSent:false,
      formLoading:false,
      availableLocales: window.AG.availableLocales,
      uploadedPhoto: false,
      foreignchecking: false,
      infoTitle: window.AG.locale == 'ro' ? 'Informații necesare pentru verificarea și confirmarea identității participantului la licitație.' : 'Mandatory information for user identity validation.',
      infoSVG: '<svg enable-background="new 0 0 512 512" height="10" viewBox="0 0 512 512" style="margin-left: 0.25rem;  margin-bottom: 0.1rem;" xmlns="http://www.w3.org/2000/svg"><path d="m277.332031 128c0 11.78125-9.550781 21.332031-21.332031 21.332031s-21.332031-9.550781-21.332031-21.332031 9.550781-21.332031 21.332031-21.332031 21.332031 9.550781 21.332031 21.332031zm0 0" /><path d="m256 405.332031c-8.832031 0-16-7.167969-16-16v-165.332031h-21.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h37.332031c8.832031 0 16 7.167969 16 16v181.332031c0 8.832031-7.167969 16-16 16zm0 0" /><path d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0" /><path d="m304 405.332031h-96c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h96c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" /></svg>',
    }
  },
  props: ['user'],
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    foreign: function(event) {
      if(event.target.checked) {
        this.foreignchecking = true;
      } else {
        this.foreignchecking = false;
      }
    },
    resetFileInput() {
      const input = this.$refs.upload;
      input.type = 'text';
      input.type = 'file';
    },
    handleFileChanges(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadedPhoto = true;
      for (var i = files.length - 1; i >= 0; i--) {
        let duplicate = false;
        this.register.files.forEach(function (element) {
          if (element.name === files[i].name) {
            duplicate = true;
          }
        });
        if (!duplicate) {
          if (files[i].size / 1000 / 1000 < 15) {
            this.register.files.push(files[i]);
          } else {
            window.showToast(this.__('document-limit-exceeded'), 'error', null, '.iziToast-wrapper-sell')
          }
        }
      }
    },
    send_form: function () {
      this.formLoading = true;
      let that = this;
      let data = new FormData();
      if (this.register.cnp) data.append('cnp', this.register.cnp);
       if (this.register.phone) data.append('phone_number', this.register.phone);
      if (this.register.foreign) data.append('foreign', this.register.foreign);
      data.append('userSelectedLanguage', $('#selectLanguage').val());

      for (var i = 0; i < this.register.files.length; i++) {
        data.append("files[" + i + "]", this.register.files[i])
      }

      axios.post('/api/update-account-info', data, {
        headers: {
          'Content-type': 'multipart/form-data'
        }
      }).then((response) => {
        window.showToast('Informațiile au fost salvate. Contul tău va fi aprobat în curând și vei primi un email de confirmare','success',null,'.iziToast-wrapper-sell')
        that.formSent = true;
        that.formLoading = false;
        location.reload();
      }).catch((error) => {
        window.showToast(error.response.data.message, 'error', null, '.iziToast-wrapper-sell')
        that.formLoading = false;
      });
    }
  },
  mounted() {
    $('.info-tool').tooltip({show: {effect:"none", delay:0}});
  },

}
</script>
